import { Action } from '@ngrx/store';

import { Pagination } from './pagination.model';

export enum PaginationActionTypes {
  Load = '[Pagination] Load Paginations',
  ChangePage = '[Pagination] Change page',
  Clear = '[Pagination] Clear page',
  Success = '[Pagination] Load Success'
}

export class PaginationLoad implements Action {
  readonly type = PaginationActionTypes.Load;
  constructor(public payload?: Pagination) {}
}

export class PaginationChangePage implements Action {
  readonly type = PaginationActionTypes.ChangePage;
  constructor(public payload?: number) {}
}

export type PaginationActionsUnion = PaginationLoad | PaginationChangePage;
